import Vue from 'vue'

import {achost, DEFAULT_HEADERS} from '../constants';

const state = () => ({
    medata: {},
    games: [],
    friends: [],
    hasTwitch: false,
    referralCode: '',
    referralEventScore: 0
});

const actions = {
    me(context) {
        return Vue.axios.get(`${achost}/api/v1/account`,
        null,
        {
            headers: DEFAULT_HEADERS
        }).then((resp) => {
            context.commit('setMedata', resp.data.account);
            return resp.data.account;
        });
    },
    changeDisplayName(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/change_nick_name`, {
            nick_name: payload.displayName
        },
        {
            headers: DEFAULT_HEADERS
        }).then(() => {
            context.commit("setDisplayName", payload.displayName);
        })
    },
    getReferralcode(context, payload) {
        return Vue.axios.get(
            `${achost}/portal/shoebill/referral_link`,
            null, 
            {
                headers: {
                    'X-Ava-Branch': 'shoebill',
                    'X-Ava-Authorization': payload
                }
            }).then((resp) => {
                let refCode = resp.data;
                context.commit("setReferralCode", refCode);
                return refCode;
            }).catch((err) => {
                console.log('Error: ', err);
            })
    },
    getListStats(context, payload) {
        return Vue.axios.get(
            `${achost}/portal/shoebill/list_stats`,
            null,
            {
                headers: {
                    'X-Ava-Branch': 'shoebill',
                    'X-Ava-Authorization': payload
                }
            }).then((resp) => {
                let events = resp.data['event_info'];
                let referralEvt = events.filter(evt => evt.src === "InternalReferral")[0];
                let referralEvtScore = referralEvt.score;
                context.commit("setReferralEventScore", referralEvtScore)
                return events;
            }).catch((err) => {
                console.log(err)
            })
    },
    changeAllowMarketingEmails(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/acp/portal/user/marketing_emails`,{
           value: payload
        },
        {
            headers: DEFAULT_HEADERS
        }).then(() => {
           context.commit("setAllowMarketingEmails", payload);
        })
    },
    resendVerificationEmail() {
        return Vue.axios.post( `${achost}/api/v1/account/resend-verification-email`,
            null,
            {
                headers: DEFAULT_HEADERS
            });
        
    },
    getGames(context) {
        return Vue.axios.post(`${achost}/api/v1/account/list_users`,
            null,
            {
                headers: DEFAULT_HEADERS
            }).then((resp) => {

            // let fakeData =  {
            //     "users":
            //     [
            //         {"id":"01FAJKGHYFF128M4T1C32CA728","account_id":"01F99CVZFADWD2WMKZ5N9685KE","project":"twitch","platform":"twitch","ident":"702748872","branch":"Live","updated_at":"2022-06-09T16:34:13Z","mark_delete_ts":{"time":"0001-01-01T00:00:00Z","valid":false},"last_login":{"time":"2021-07-14T13:32:47Z","valid":true},"login_days_streak":{"Int64":0,"Valid":true}},
            //         {"id":"01F99E199FN5SSHK0DAV1X8V62","account_id":"01F99CVZFADWD2WMKZ5N9685KE","project":"acp","platform":"portal","ident":"01F99E199CN2WYY371VEX17RQ2","branch":"Live","updated_at":"2022-07-14T07:47:11Z","mark_delete_ts":{"time":"0001-01-01T00:00:00Z","valid":false},"last_login":{"time":"2022-07-14T07:47:12Z","valid":true},"login_days_streak":{"Int64":0,"Valid":true}},
            //         {"id":"01F99CW006A5QGK65MYMPY3FGK","account_id":"01F99CVZFADWD2WMKZ5N9685KE","project":"cataclysm","platform":"steam","ident":"76561199185032022","branch":"Live","updated_at":"2022-06-09T16:21:37Z","mark_delete_ts":{"time":"0001-01-01T00:00:00Z","valid":false},"last_login":{"time":"2021-12-01T18:13:50Z","valid":true},"login_days_streak":{"Int64":0,"Valid":true}},
            //         {"id":"01F9KM7NWPCG72CT3F0SQT0F9J","account_id":"01F99CVZFADWD2WMKZ5N9685KE","project":"shoebill","platform":"steam","ident":"76561199185032022","branch":"QA","updated_at":"2022-06-09T17:48:41Z","mark_delete_ts":{"time":"0001-01-01T00:00:00Z","valid":false},"last_login":{"time":"2021-07-02T12:48:57Z","valid":true},"login_days_streak":{"Int64":0,"Valid":true}},
            //         {"id":"01F9KM7NWPCG72CT3F0SQT0F9J","account_id":"01F99CVZFADWD2WMKZ5N9685KE","project":"tortoise","platform":"steam","ident":"76561199185032022","branch":"QA","updated_at":"2022-06-09T17:48:41Z","mark_delete_ts":{"time":"0001-01-01T00:00:00Z","valid":false},"last_login":{"time":"2021-07-02T12:48:57Z","valid":true},"login_days_streak":{"Int64":0,"Valid":true}},
            //         {"id":"01F9KM7NWPCG72CT3F0SQT0F9J","account_id":"01F99CVZFADWD2WMKZ5N9685KE","project":"jackdaw","platform":"steam","ident":"76561199185032022","branch":"QA","updated_at":"2022-06-09T17:48:41Z","mark_delete_ts":{"time":"0001-01-01T00:00:00Z","valid":false},"last_login":{"time":"2021-07-02T12:48:57Z","valid":true},"login_days_streak":{"Int64":0,"Valid":true}},
            //     ]
            // }

            let games = resp.data.users.filter(function(user) {
                if (user.project == 'twitch') {
                    context.commit("setHasTwitch", true)
                }
                return user.project != 'acp' && user.project != 'twitch';
            })

            context.commit("setGames", games);

            return games;
        })   
    },
    getAllFriends(context) {
        return Vue.axios.post(`${achost}/api/v1/account/all_friends`,
        null, // payload
        {
            headers: DEFAULT_HEADERS
        }).then((resp) => {
            let friends = resp.data;
            context.commit("setFriends", friends);
            return friends;
        })
    },
    addFriend(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/add_friend`,{
            friend_display_name: payload.friendDisplayName
        },
        {
            headers: DEFAULT_HEADERS
        })
    },   
    removeFriend(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/remove_friend`,{
            friend_account_id: payload.friendAccountID
        },
        {
            headers: DEFAULT_HEADERS
        })
    }, 
    declineFriendRequest(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/decline_friend_request`,{
            friend_account_id: payload.friendAccountID
        },
        {
            headers: DEFAULT_HEADERS
        })
    },  
    approveFriendRequest(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/approve_friend_request`,{
            friend_account_id: payload.friendAccountID
        },
        {
            headers: DEFAULT_HEADERS
        })
    },  
    removeFriendRequest(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/remove_friend_request`,{
            friend_account_id: payload.friendAccountID
        },
        {
            headers: DEFAULT_HEADERS
        })
    }, 
    muteFriend(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/mute_friend`,{
            friend_account_id: payload.friendAccountID
        },
        {
            headers: DEFAULT_HEADERS
        })
    },
    unmuteFriend(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/unmute_friend`,{
            friend_account_id: payload.friendAccountID
        },{
            headers: DEFAULT_HEADERS
        })
    },
    blockFriend(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/block_friend`,{
            friend_account_id: payload.friendAccountID
        },
        {
            headers: DEFAULT_HEADERS
        })
    },
    unblockFriend(context,payload) {
        return Vue.axios.post(`${achost}/api/v1/account/unblock_friend`,{
            friend_account_id: payload.friendAccountID
        },
        {
            headers: DEFAULT_HEADERS
        })
    },
    getHasTwitch(context) {
        return Vue.axios.get(`${achost}/portal/api/twitch/is-linked`,{
            headers: DEFAULT_HEADERS
        }).then((resp) => {
          const hasTwitch = resp.data.status === "true"
          context.commit("setHasTwitch", hasTwitch );
          return hasTwitch;
        })
    },
    unlinkTwitch(context) {
        return Vue.axios.delete(`${achost}/portal/api/twitch/link`,{
            headers: DEFAULT_HEADERS
        }).then(() => {
          context.commit("setHasTwitch", false);
          return ;
        })
    },
    reportDisplayName(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/report_profane_displayname`,{
            reported_account_id: payload.reported_account_id,
            reported_display_name: payload.reported_display_name,
            message: "block friend"
        },
        {
            headers: DEFAULT_HEADERS
        })
    },
     
};

const mutations = {
    setMedata(state, value) {
        state.medata = value;
    },
    setDisplayName(state, value) {
        state.medata.nick_name = value;
    },
    setAllowMarketingEmails(state, value) {
        state.medata.promo_email_ok = value;
    },
    setGames(state, value) {
        state.games = value;
    },    
    setFriends(state, value) {
       state.friends = value;
    },
    setHasTwitch(state, value) {
        state.hasTwitch = value;
    },
    setReferralCode(state, value) {
        state.referralCode = value;
    },
    setReferralEventScore(state, value) {
        state.referralEventScore = value;
    }
}

export const account = {
    namespaced: true,
    actions,
    mutations,
    state
}